import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Box from '@material-ui/core/Box'
import YourCoaches from './your-coaches'
import SessionsSection from './sessions/sessions-section'
import DiscoverMoreGolf from './discover-more-golf'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(3),
    },
  },
  section: {
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
}))

export default ({
  students,
  selectedStudent,
  lessonCreditBalances,
  onBookClick,
}) => {
  const student = students.find(({ id }) => id === selectedStudent)
  const classes = useStyles()
  const now = new Date()
  const balances = lessonCreditBalances || []
  const coaches = student?.coaches || []

  coaches.forEach(coach => {
    const filteredById = balances.filter(({ lessonType }) => {
      return lessonType.coach.id === coach.id
    })
    coach.lessonCreditBalances = filteredById.filter(
      ({ remainingCredits, expiresAt }) => {
        return (
          remainingCredits > 0 && (expiresAt > now.toISOString() || !expiresAt)
        )
      },
    )
  })

  if (!student) {
    return null
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.section}>
        <SessionsSection
          studentId={selectedStudent}
          onBookClick={onBookClick}
        />
      </Box>
      {coaches.length ? (
        <Box className={classes.section}>
          <YourCoaches coaches={coaches} />
        </Box>
      ) : null}
      <Box className={classes.section}>
        <DiscoverMoreGolf />
      </Box>
    </Box>
  )
}
